module.exports = __webpack_public_path__ + "img/ins_search.ed925375.png";